<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">THANK YOU</span> to Jackee, Kate, Kim, and Matthew for your help and encouragement while I was writing this. Thanks to Charlie and Pepper for sitting on me while I was writing this and for meowing loudly when I needed to concentrate.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?208eba48